module.exports = __webpack_public_path__ + "static/media/cert_12487.cc194233.jpg";